export default {
    login: {
        method: 'post',
        url: '/login'
    },
    menus: {
        method: 'get',
        url: '/common/menus'
    },
    operatorsMenus: {
        method: 'get',
        url: '/operators/:id/menus'
    },
    list: {
        method: 'get',
        url: '/users'
    }
};



// WEBPACK FOOTER //
// ./src/api/user.js